<template>
  <section>
    <div id="#app">
      <iframe
        :src="src1"
        width="100%"
        height="800"
        frameborder="0"
        scrolling="auto"
        id="iframename"
        name="iframename"
      ></iframe>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return { src1: "#" };
  },
  mounted() {
    // let phone = this.$route.query.Phone;
    // console.log(phone);
    // let url =
    //   "https://report.51i.cc/WebReport/decision/view/report?viewlet=JJVC%252FJJVC_EcpUpdate.cpt";
    // if (phone != null) {
    //   this.src1 = url + "&phone=" + phone;
    // } else {
    //   this.src1 = url;
    // }
    this.src1 ="https://report.51i.cc/WebReport/decision/view/report?viewlet=Report%252FJJVC_product_info.cpt";
  }
};
</script>